// Query parameter keys used across the application
export const FLEET_ID_QUERY_PARAM_KEY = 'fleet_id';
export const FILTER_QUERY_PARAM_KEY = 'filter';
